import React from "react";
import HalfScreenSection from "./HalfScreenSection";
import { Box, Center, Heading, Link } from "@chakra-ui/react";
import Card from "./Card";

const projects = [
  {
    title: "Best International Money Transfer Apps in 2026",
    description: <Link href="/blog/best-transfer-apps-2026" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/money_transfer.png"),
  },
  {
    title: "Top 10 Strongest Currencies in the World",
    description: <Link href="/blog/top-10-strongest-currencies-2026" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/currency_map.png"),
  },
  {
    title: "Avoiding Currency Exchange Scams While Traveling",
    description: <Link href="/blog/avoiding-currency-exchange-scams" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/currency_exchange.png"),
  },
  {
    title: "Cheapest Destinations to Visit by Season",
    description: <Link href="/blog/cheapest-destinations-by-season" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/destination.png"),
  },
];

const BlogSection = () => {
  return (
    <HalfScreenSection
      backgroundColor="gray.800"
      isDarkBackground
      p={6}
      spacing={8}
    >
      <Heading as="h1" id="blog-section" justifyContent="space-between">
        Official Swiftchang Blog
      </Heading>
      <Box
        display="grid"
        gridTemplateColumns={{ base: "1fr", md: "repeat(2,minmax(0,1fr))", lg: "repeat(4,minmax(0,1fr))" }}
        gridGap={{ base: 6, md: 8 }}
        maxWidth="1500px"
        margin="0 auto"
      >
        {projects.map((project) => (
          <Card
            key={project.title}
            title={project.title}
            description={project.description}
            imageSrc={project.getImageSrc()}
            imageBorder="2px solid #d3d3d3"
            imageHref="#"
          />
        ))}
      </Box>
    </HalfScreenSection>
  );
};

export default BlogSection;
